export const environment = {
    production: false,

    clientId: '24die2srjr0s9ghul53eah13b3',
    region: 'us-east-1',
    identityPoolId: 'us-east-1:75052f5f-603c-42b8-a2cd-fa10583afc2e',
    userPoolId: 'us-east-1_3bqlSPvFJ',
  
    urlBase: document.getElementsByTagName('base')[0].href,
    urlCognito: 'iclogintest.auth.us-east-1.amazoncognito.com',
    urlApi: 'https://qa-api-login.azurewebsites.net/',
    encodeKey: 'Iconstruye_nmp',
    idProductoDefecto: '72925772dd1451ad3c4722d0',
    recaptchaKey: '6LfDH60ZAAAAAGKOakXGGQVQ8AHfSrl-7dUYJMFD',

    urlBannerIConstruye: 'https://www.iconstruye.com',
    urlBannerAgilice: 'https://info.iconstruye.com/nuevo-acceso-clientes',
    urlBannerMarketplace: 'https://marketplace.iconstruye.com/',
    instrumentationKey: '515c2f8f-5c04-4d5d-bb46-aad27612cf0e',
    applicationFullName: 'qa-spa-login'
};
